import styled from 'styled-components'
import { GRAYSCALE_300, PRIMARY } from '../../styles/colors'

interface OuterCircleProps {
  $checked?: boolean
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OuterCircle = (styled.div<OuterCircleProps>`
  border: 2px solid ${props => props.$checked ? PRIMARY : GRAYSCALE_300};
  border-radius: 100%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InnerCircle = (styled.div`
  width: 10px;
  height: 10px;
  background-color: ${PRIMARY};
  border-radius: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
